import { Link } from "react-router-dom"
import { TablePageLayout } from "~/layouts/table-page-layout"
import { adminLocationsPath, adminPlansPath } from "~/common/paths"
import { Button } from "~/ui/button"

export const AdminDashboardScreen = () => {
  return (
    <TablePageLayout>
      <div className="space-y-4">
        <h1 className="text-2xl font-bold">Admin Dashboard</h1>
        <p>Manage application data.</p>
        <div className="flex gap-4">
          <Link to={adminLocationsPath({})}>
            <Button variant="outline">Manage Locations</Button>
          </Link>
          <Link to={adminPlansPath({})}>
            <Button variant="outline">Manage Plans</Button>
          </Link>
          {/* Add more admin links here as needed */}
        </div>
      </div>
    </TablePageLayout>
  )
}
